import { render, staticRenderFns } from "./MindsDashboard.vue?vue&type=template&id=e7f3f44a&scoped=true"
import script from "./MindsDashboard.vue?vue&type=script&lang=js"
export * from "./MindsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MindsDashboard.vue?vue&type=style&index=0&id=e7f3f44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f3f44a",
  null
  
)

export default component.exports